import { Dropdown, Form, Input, Tooltip } from "antd";
import { debounce } from "lodash";
import { memo, useCallback, useRef, useState } from "react";
import { Table } from "../../../../components";
import { keys } from "../../../../constants";
import { rid } from "../../../../helpers";
import i18n, { languageKeys } from "../../../../i18n";
import { apiLayDsXaPhuong } from "../../../QuanLyHeThong/QuanLyDanhMuc/apisDanhMuc/apisDanhMuc";
import { fieldXa } from "../../../QuanLyHeThong/QuanLyDanhMuc/fieldsDanhMuc";
import { columnsTHX } from "../../columnsTiepDon";
import { fieldTiepDon } from "../../fieldsTiepDon";
import style from "./searchThx.module.less";

const SearchTHX = ({ form, name = fieldTiepDon.t_h_x, readOnly = false, onSelect = () => {} }) => {
  const inputRef = useRef();
  const valInputRef = useRef();
  const [visible, setVisible] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [listTHX, setListTHX] = useState([]);
  const [loadingThx, setLoadingThx] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const searchTHX = useCallback(
    debounce((value) => {
      layTHX(value);
    }, 1000),
    []
  );

  const layTHX = async (search_string = "") => {
    setLoadingThx(true);
    let res = await apiLayDsXaPhuong({
      page: 1,
      search_string: search_string,
      limit: keys.limit,
    });
    if (res) {
      setListTHX(res.result);
    }
    setLoadingThx(false);
  };

  const onClickRow = (val) => {
    setSearchString("");
    setVisible(false);
    onSelect(val);
    valInputRef.current.focus();

    // const tinh = val.TEN_TINH_THANH;
    // const huyen = val.TEN_QUAN_HUYEN;
    // const xa = val.TEN_PHUONG_XA;
    form.setFields([
      {
        name: name,
        // value: `${tinh}, ${huyen}, ${xa}`,
        value: val[fieldXa.code_thx],
        errors: [],
      },
    ]);
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchString(value);
    searchTHX(value);
  };

  if (readOnly) {
    return (
      <Tooltip title={form.getFieldValue(name)} placement="bottomLeft">
        <Form.Item
          name={name}
          label={i18n.t(languageKeys.field_THX)}
          // rules={[
          //   {
          //     required: true,
          //     message: i18n.t(languageKeys.vui_long_nhap),
          //   },
          // ]}
        >
          <Input readOnly />
        </Form.Item>
      </Tooltip>
    );
  }

  return (
    <Dropdown
      trigger="click"
      visible={visible}
      onVisibleChange={(bool) => {
        setVisible(bool);

        if (bool) {
          layTHX();
          setTimeout(() => {
            inputRef.current?.focus();
          }, 100);
        } else {
          setSearchString("");
        }
      }}
      placement="bottomLeft"
      overlay={
        <div className={style["popup-ctn"]}>
          <div className={style["input"]}>
            <Input placeholder={i18n.t(languageKeys.common_Tim_kiem)} ref={inputRef} value={searchString} onChange={handleSearch} />
          </div>

          <Table
            columns={columnsTHX}
            dataSource={listTHX.map((item) => ({ ...item, key: rid() }))}
            className={style["table"]}
            scroll={{ y: 250, scrollToFirstRowOnChange: false }}
            style={{ width: 700 }}
            onClickRow={onClickRow}
            loading={loadingThx}
          />
        </div>
      }
      overlayClassName={style["popup-thx"]}
    >
      <Tooltip title={form.getFieldValue(name)} placement="bottomLeft">
        <Form.Item name={name} label={i18n.t(languageKeys.field_THX)}>
          <Input
            ref={valInputRef}
            readOnly
            placeholder={i18n.t(languageKeys.common_Nhap)}
            style={{ cursor: "pointer" }}
            onPressEnter={() => {
              if (!visible) {
                setVisible(true);
                layTHX();
                setTimeout(() => {
                  inputRef.current?.focus();
                }, 100);
              }
            }}
          />
        </Form.Item>
      </Tooltip>
    </Dropdown>
  );
};

export default memo(SearchTHX);
